import { Molecule, wrap, today } from 'AppReact';
import styled from 'styled-components';
import { Mr1 } from 'wrappers';
import { Icon, SecondaryTextSm } from 'atoms';
import { format, isSameDay, parseISO } from 'date-fns';
import { CalendarSvg } from 'components/icons';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(Icon, Mr1),
      name: 'CalendarIcon',
      renderIf: ({ date, displayWhenNull }) => date || displayWhenNull,
      displayValue: ({ date }) => {
        let color = window?.settings?.secondary_color ?? '#04333B';
       
        if (date && parseISO(date) < today()) {
          color = '#E41D1D'
        }
        if (date && isSameDay(parseISO(date), today())) {
          color = '#1AAA60'
        }

        return CalendarSvg({ bold: true, width: 15, height: 15, color })
      },
    },
    {
      component: SecondaryTextSm,
      name: 'DateDisplay',
      renderIf: ({ date, displayWhenNull }) => date || displayWhenNull,
      displayValue: ({ date, todayText }) => { 
        if (!date) return "-";
        const parsedDate = parseISO(date);
        return todayText && isSameDay(parsedDate, today()) ? "Today" : format(parsedDate, 'MM/dd/yy');
      }
    }
  ],
});
